import styled from "styled-components/macro";

export const BackToProjectLink = styled.a`
  position: fixed;
  top: 25px;
  left: 25px;
  z-index: 100000000;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: var(--grey-3);
  color: var(--grey-0);
  border-radius: 18px;
  font-size: 14px;
  font-family: Inter;
  font-weight: 500;
  text-decoration: none;
  opacity: 0.7;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }

  svg {
    width: 14px;
    height: 14px;
    stroke: var(--grey-0);
  }
`;

export const StyledContainer = styled.div`
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--grey-0);
  }

  .viewer {
    border-top: 1px solid #aaa;
    position: absolute;
    /* top: 60px; */
    top: 0;
    left: 0px;
    right: 0px;
    bottom: 0px;
    user-select: none;
  }

  .viewport {
    position: relative;
    width: 100%;
    height: 100%;

    .dots {
      opacity: 0.2;
      width: 100000px;
      height: 100000px;
      position: absolute;
      top: -50000px;
      left: -50000px;
      z-index: -100000000;
    }
  }

  .selection-box-info {
    position: fixed;
    top: 400px;
    left: 400px;
    text-align: left;
    background: white;
    padding: 10px;
    z-index: 10000000;
  }

  &.is-space-dragging {
    cursor: grab !important;
  }

  .infinite-viewer-scroll-bar {
    visibility: hidden;
  }

  .toast {
    position: fixed;
    bottom: 20px;
    right: 75px;
    background: var(--primary-cta-active);
    padding: 7px 12px;
    font-size: 15px;
    font-family: Inter;
    font-weight: 500;
    color: var(--text-highlight);
    border-radius: 5px;
    z-index: 100000000;
  }

  .error {
    position: fixed;
    bottom: 20px;
    right: 75px;
    background: var(--primary-cta-active);
    padding: 7px 12px;
    font-size: 15px;
    font-family: Inter;
    font-weight: 500;
    color: white;
    background: red;
    border-radius: 5px;
    z-index: 100000001;
  }

  .debug-panel {
    position: fixed;
    bottom: 10px;
    left: 10px;
    width: 150px;
    opacity: 0.7;
    font-size: 13px;
    padding: 5px;
    background: white;
  }
`;
